import { LayoutGrid, List } from "lucide-react";

import { cn } from "@/utils/cn";

export type ViewMode = "grid" | "list";

type Props = {
  value: ViewMode;
  onChange: (v: ViewMode) => void;
};

export function ViewToggle({ value, onChange }: Props) {
  return (
    <div
      role="radiogroup"
      aria-label="View mode"
      className="inline-flex rounded border border-slate-200 bg-white p-0.5"
    >
      <Btn
        active={value === "grid"}
        onClick={() => onChange("grid")}
        label="Grid view"
      >
        <LayoutGrid className="h-4 w-4" aria-hidden="true" />
      </Btn>
      <Btn
        active={value === "list"}
        onClick={() => onChange("list")}
        label="List view"
      >
        <List className="h-4 w-4" aria-hidden="true" />
      </Btn>
    </div>
  );
}

function Btn({
  active,
  onClick,
  label,
  children,
}: {
  active: boolean;
  onClick: () => void;
  label: string;
  children: React.ReactNode;
}) {
  return (
    <button
      type="button"
      role="radio"
      aria-checked={active}
      aria-label={label}
      onClick={onClick}
      className={cn(
        "rounded px-2 py-1 text-slate-500 transition",
        active ? "bg-slate-100 text-slate-900" : "hover:bg-slate-50",
      )}
    >
      {children}
    </button>
  );
}
